import { connect } from 'react-redux';
import StartAtRetirementView from './StartAtRetirementView';
import {
  currentClientId,
  iterator,
  isPopulatedSelector,
  isGoingForwardSelector,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import { updateData } from '../../AdvWorkflow/AdvWorkflowActions';
import { healthcareGoalSelector, yearsOptionsSelector } from '../HealthcareWorkflowSelector';
import { BACKEND_KEY } from '../HealthcareWorkflowConstants';

const mapStateToProps = (state, ownProps) => {
  const healthcareGoal = healthcareGoalSelector(state, ownProps);

  const {
    StartAtRetirement: startAtRetirement,
    StartYear: startYear,
    EstimateExpenses: estimateExpenses,
    AnnualExpense: annualExpense,
  } = healthcareGoal;

  return {
    clientId: currentClientId(state, ownProps),
    yearsOptions: yearsOptionsSelector(state, ownProps).map(year => ({
      label: year.toString(),
      value: year,
    })),
    startAtRetirement,
    startYear,
    estimateExpenses,
    annualExpense,
    iterator: iterator(state, ownProps),
    isPopulated: isPopulatedSelector(state, ownProps),
    isGoingForward: isGoingForwardSelector(state, ownProps),
  };
};

const mapDispatchToProps = dispatch => ({
  updateStartAtRetirement: (workflowId, clientId) => StartAtRetirement =>
    dispatch(updateData({ [BACKEND_KEY]: { StartAtRetirement } }, workflowId, clientId)),
  updateStartYear: (workflowId, clientId) => ({ value: StartYear }) =>
    dispatch(updateData({ [BACKEND_KEY]: { StartYear } }, workflowId, clientId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StartAtRetirementView);
